// ============================================
// モジュール読み込み
// ============================================
import { viewport } from './libs/switchViewport';
import { inViewAnm, lenisPageScroll } from './libs/Scroll';
import { drawer, fixedHeader, megaMenu } from './libs/Header';
import { addAutoFunc, confirmForm, numKeyFunc } from './libs/Form';
// import { accordionFunc } from './libs/Accordion';
// import { blogSort } from './libs/Blog';
// import { createIndex } from './libs/CreateIndex';
// import { numKeyFunc } from './libs/Form';
// import { articleTable, ScrollHintFunc } from './libs/ScrollHint';
// import { modal } from './libs/Modal';
// import { slider } from './libs/Slider';
// import { tabFunc } from './libs/Tab';

// 実行
// ==========================
window.addEventListener('DOMContentLoaded', () => {
  viewport();
  fixedHeader();
  drawer();
  megaMenu();
  // createIndex();
  addAutoFunc();
  numKeyFunc();
  confirmForm();
  lenisPageScroll();
  // accordionFunc();
  // articleTable();
  // ScrollHintFunc();
  // tabFunc();
});

window.addEventListener('load', () => {
  document.body.classList.add('is-loaded');
  inViewAnm();
  // modal();
  // blogSort();
  // slider();
});
